var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhoto = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M11 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M1.5 4A1.5 1.5 0 0 0 0 5.5v21A1.5 1.5 0 0 0 1.5 28h29a1.5 1.5 0 0 0 1.5-1.5v-21A1.5 1.5 0 0 0 30.5 4zM2 26v-3.586l4-4L13.586 26zm2.94-9.354L2 19.586V6h28v17.586l-9.94-9.94a1.5 1.5 0 0 0-2.12 0L11 20.586l-3.94-3.94a1.5 1.5 0 0 0-2.12 0M16.413 26l-4-4L19 15.414 29.586 26z",
  clipRule: "evenodd"
})));
export default SvgPhoto;